<template>
    <div>
        <div class="storageGatewayWarning-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/storageGatewayMonitor">StorageGateway</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="storageGatewayWarning-top">
                        <storage-gateway-warning-search></storage-gateway-warning-search>
                    </div>
                    <table-storage-gateway-warning></table-storage-gateway-warning>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import StorageGatewayWarningSearch from '../storage_gateway/StorageGatewayWarningSearch'
    import TableStorageGatewayWarning from '../storage_gateway/TableStorageGatewayWarning'

    export default {
        name: 'StorageGatewayWarning',
        components: {
            StorageGatewayWarningSearch,
            TableStorageGatewayWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                name:''
            }
        },
         methods:{
         	// 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/storageGatewayDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .storageGatewayWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .storageGatewayWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/storage_gateway/StorageGatewayWarning.vue